import { Dispatch, SetStateAction } from 'react';

export type NavigationTab = {
  isMenuClosed: boolean;
  setIsMenuClosed: Dispatch<SetStateAction<boolean>>;
  collapsedMenus: string[];
  handleMenuCollapse: (menu: string, hasSubMenus?: boolean) => void;
  collapsedSubMenus?: string[];
};

export enum Menus {
  GET_STARTED = 'get-started',
  BRANDING_STYLEGUIDE = 'branding-styleguide',
  GENERAL_COMPONENTS = 'general-components',
  DATA_VISUALISATION = 'data-visualization',
  DEV_RESOURCES = 'dev-resources',
  CHART_MATCH = 'chart-match',
}

export enum SubMenus {
  LIENS = 'lines',
  BARS = 'bars',
  MAPS = 'maps',
  TABLES = 'tables',
  CIRCULARS = 'circulars',
  DIAGRAMS = 'diagrams',
  OTHERS = 'others',
}
